<template>
  <div  v-show="showLogin">
    <Head :title="__('Log In')" />
    <form @submit.prevent="attempt"
      class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto">
      <h2 class="text-2xl text-center font-normal mb-6">
        {{ __('Welcome Back!') }}
      </h2>
      <DividerLine />
      <div class="mb-6">
        <label class="block mb-2" for="email">{{ __('Email Address') }}</label>
        <input v-model="form_login.email" class="form-control form-input form-control-bordered w-full"
          :class="{ 'form-control-bordered-error': form_login.errors.has('email') }"
          id_contrato="email" type="email" name="email" autofocus="" required/>
        <HelpText class="mt-2 text-red-500" v-if="form_login.errors.has('email')">
          {{ form_login.errors.first('email') }}
        </HelpText>
      </div>

      <div class="mb-6">
        <label class="block mb-2" for="password">{{ __('Password') }}</label>
        <input v-model="form_login.password" class="form-control form-input form-control-bordered w-full"
          :class="{ 'form-control-bordered-error': form_login.errors.has('password') }"
          id_contrato="password" type="password" name="password" required />
        <HelpText class="mt-2 text-red-500" v-if="form_login.errors.has('password')">
          {{ form_login.errors.first('password') }}
        </HelpText>
      </div>

      <div class="flex mb-6">
        <Checkbox
          @change="() => (form_login.remember = !form_login.remember)"
          :model-value="form_login.remember"
          dusk="remember-button"
          :label="__('Remember me')"
        />

        <div
          v-if="supportsPasswordReset || forgotPasswordPath !== false"
          class="ml-auto"
        >
          <Link
            v-if="forgotPasswordPath === false"
            :href="$url('/password/reset')"
            class="text-gray-500 font-bold no-underline"
            v-text="__('Forgot your password?')"
          />
          <a
            v-else
            :href="forgotPasswordPath"
            class="text-gray-500 font-bold no-underline"
            v-text="__('Forgot your password?')"
          />
        </div>
      </div>

      <Button class="w-full flex justify-center" type="submit" :loading="form_login.processing">
        <span>
          {{ __('Log In') }}
        </span>
      </Button>
    </form>
  </div>
  <div v-if="showModal">
    <div class="bg-white dark:bg-gray-800 shadow rounded-lg p-8 max-w-[25rem] mx-auto">
      <h1 class="font-normal text-xl md:text-xl mb-3 flex items-center"><span>Seleccione Contrato</span></h1>
      <div class="mb-6 mt-4">
        <label class="block mb-2" for="email">{{ __('Contratos') }}</label>
        <select v-model="form_contract.id_contrato" name="contract"
          class="w-full block form-control form-control-bordered form-input">
          <option selected disabled value="">- Seleccione - </option>
          <option v-for="contract in contracts" :key="contract.id_contrato" :value="contract.id_contrato">{{ contract.nombre }}</option>
        </select>
        <HelpText class="mt-2 text-gray-500">
          Seleccione el contrato con el cual desea operar en la plataforma.
        </HelpText>
      </div>
      <DefaultButton class="w-full flex justify-center" @click="setContract">
        <span>
          {{ __('Confirmar') }}
        </span>
      </DefaultButton>
    </div>
  </div>
</template>

<script>
import Auth from '@/layouts/Auth'
import axios from 'axios';
import { Button, Checkbox } from 'laravel-nova-ui'

export default {
  name: 'LoginPage',
  layout: Auth,
  components: {
    Checkbox,
    Button,
  },

  data: () => ({
    form_login: Nova.form({
      email: '',
      password: '',
      remember: false,
    }),
    form_contract: {
      id_contrato: ''
    },
    supportsPasswordReset:true,
    forgotPasswordPath:false,
    showLogin: true,
    showModal: false,
    showOnboarding: false,
    path: '/',
    contracts: [],
    buttonBack: 'Regresar a Inicio de sesión.'
  }),
  methods: {
    async attempt() {
      try {
        const { redirect, contracts } = await this.form_login.post(Nova.url('/login'))
        if (redirect !== undefined && redirect !== null) {
          this.path = { url: redirect, remote: true }
          if (contracts.length > 1) {
            this.contracts = contracts
            this.showLogin = false
            this.showModal = true
          } else {
            Nova.visit(this.path)
          }
        }
      } catch (error) {
        if (error.response?.status === 500) {
          Nova.error(this.__('There was a problem submitting the form.'))
        }
      }
    },
    async setContract() {
      try {
        if (this.form_contract.id_contrato == '') {
          Nova.error('Debe seleccionar un Contrato.')
        } else {
          const response = await axios.post(Nova.url('/contract/set'), {
            id: this.form_contract.id_contrato
          })

          if (response.data.status == 'ok') {
            Nova.visit(this.path)
          } else {
            Nova.error('Error al seleccionar Contrato.')
          }
        }
      } catch (error) {
        if (error.response?.status === 500) {
          Nova.error(this.__('There was a problem submitting the form.'))
        }
      }
    },
  },
  computed: {
  },
  mounted() {
  },
}
</script>
